const setFloatingCards = () => {
  const CARDS_ID = "paywall-cards";
  const FLOATING_CARDS_ID = "paywall-floating-cards";

  const paywallCards = document.getElementById(CARDS_ID);

  if (paywallCards) {
    const clone = paywallCards.cloneNode(true);

    const buttons = clone.querySelectorAll(".card-content-buttons button");

    for (const button of buttons) {
      button.setAttribute("data-isFloatingCard", true);
    }

    clone.id = FLOATING_CARDS_ID;
    clone.classList.add("hide-info-cards", "hide-cards");
    paywallCards.parentNode.appendChild(clone);
  }
};

module.exports = {
  init: () => {
    setFloatingCards();
  },
};



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/animations/floatingCards.js